// Import required modules from React and React Router
import { Route, Routes } from "react-router-dom";
import { Suspense, lazy } from "react";
import Courses from "../pages/courses/Courses";
import AddCourses from "../pages/courses/AddCourses";
import ScrollToTop from "../config/ScrollToTop";
import WorkoutExercises from "../pages/workout/WorkoutExercises";
import UpdateExercises from "../pages/exercises/UpdateExercises";
import UpdateWorkOuts from "../pages/workout/UpdateWorkOuts";
import UpdateWorkoutExercises from "../pages/workout/UpdateWorkoutExercises";
import UpdateChallenges from "../pages/challenges/UpdateChallenges";
import CoursesClass from "../pages/courses/CoursesClass";
import EditCourses from "../pages/courses/EditCourses";
import UpdateCourseClass from "../pages/courses/UpdateCourseClass";
import ChallengeDetail from "../pages/challenges/ChallengeDetail";
import ExerciseDetail from "../pages/exercises/ExerciseDetail";
import WorkoutDetail from "../pages/workout/WorkoutDetail";
import CourseDetail from "../pages/courses/CourseDetail";
import MoreAddCourseClass from "../pages/courses/MoreAddCourseClass";
import RewardDetail from "../pages/reward/RewardDetail";
import UpdateBadges from "../pages/badges/UpdateBadges";
import PrivacyPolicy from "../pages/privacyPolicy";
import TermConditions from "../pages/termConditions";

// Lazy load each component
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const ProtectedRoute = lazy(() => import("./ProtectedRoute"));
const Login = lazy(() => import("../pages/auth/Login"));
const Users = lazy(() => import("../pages/users/Users"));
const Workouts = lazy(() => import("../pages/workout/Workouts"));
const AddWorkOuts = lazy(() => import("../pages/workout/AddWorkOuts"));
const Exercises = lazy(() => import("../pages/exercises/Exercises"));
const Notifaction = lazy(() => import("../pages/notifaction/Notifaction"));
const Challenges = lazy(() => import("../pages/challenges/Challenges"));
const AddChallenges = lazy(() => import("../pages/challenges/AddChallenges"));
const AddBadges = lazy(() => import("../pages/badges/AddBadges"));
const AddNotifaction = lazy(
  () => import("../pages/notifaction/AddNotifaction")
);
const AddExercises = lazy(() => import("../pages/exercises/AddExercises"));
const UserDetail = lazy(() => import("../pages/users/UserDetail"));
const Reward = lazy(() => import("../pages/reward/Reward"));
const Badges = lazy(() => import("../pages/badges/Badges"));

const AppRoutes = () => {
  return (
    <Suspense
      fallback={
        <div className="h-screen flex justify-center items-center">
          {" "}
          <div className="p-2 bg-white rounded-2xl w-56 border-2 border-darkCyan animated-image">
            <img src="/images/logo.png" className="w-full" alt="" />
          </div>
        </div>
      }
    >
      <ScrollToTop />
      <Routes>
        <Route path="/auth/login" element={<Login />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/termConditions" element={<TermConditions />} />
        <Route path="/" element={<ProtectedRoute />}>
          <Route path="/" element={<Dashboard />} />
          {/* user  */}
          <Route path="/users" element={<Users />} />
          <Route path="/users/:id" element={<UserDetail />} />
          {/* workout  */}
          <Route path="/workouts" element={<Workouts />} />
          <Route path="/workouts/add" element={<AddWorkOuts />} />
          <Route
            path="/workouts/exercises/:id"
            element={<WorkoutExercises />}
          />
          <Route
            path="/workouts/exercises/update/:id"
            element={<UpdateWorkoutExercises />}
          />
          <Route path="/workouts/:id" element={<UpdateWorkOuts />} />
          <Route
            path="/workouts/detail/:workoutId"
            element={<WorkoutDetail />}
          />
          {/* Exercises  */}
          <Route path="/exercises" element={<Exercises />} />
          <Route path="/exercises/add" element={<AddExercises />} />
          <Route path="/exercises/edit/:id" element={<UpdateExercises />} />
          <Route
            path="/exercises/detail/:exerciseId"
            element={<ExerciseDetail />}
          />
          {/* Notifaction  */}
          <Route path="/notification" element={<Notifaction />} />
          <Route path="/notification/add" element={<AddNotifaction />} />
          {/* Challenges  */}
          <Route path="/challenges" element={<Challenges />} />
          <Route path="/challenges/add" element={<AddChallenges />} />
          <Route path="/challenges/edit/:id" element={<UpdateChallenges />} />
          <Route
            path="/challenges/detail/:challengeId"
            element={<ChallengeDetail />}
          />
          {/* courses  */}
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/add" element={<AddCourses />} />
          <Route path="/courses/edit/:id" element={<EditCourses />} />
          <Route path="/courses/class/:courseId" element={<CoursesClass />} />
          <Route
            path="/courses/class/edit/:id"
            element={<UpdateCourseClass />}
          />
          <Route path="/courses/detail/:courseId" element={<CourseDetail />} />
          <Route
            path="/courses/class/add/:courseId"
            element={<MoreAddCourseClass />}
          />
          {/* Reward  */}
          <Route path="/reward" element={<Reward />} />
          <Route path="/reward/:rewardId" element={<RewardDetail />} />
          {/* Badges  */}
          <Route path="/badges" element={<Badges />} />
          <Route path="/badges/add" element={<AddBadges />} />
          <Route path="/badges/edit/:id" element={<UpdateBadges />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
